<template>
  <div class="welcome-wrapper">
    <p style="text-align: center;font-size: 24px;position: relative;top:20px;z-index: 1">欢迎使用学生体质健康公共服务平台</p>
     <!--<div class="statistics">
       <div class="menu-title">
         <div class="blue-icon"></div>
         <p class="blue-text">统计数据</p>
       </div>
       <div class="statistics-list">
         <ul>
           <li>
             <div class="statistics-bg" style="background-color: #DBEDFE">
               <img class="statistics-img" src="../../common/img/static1.png">
             </div>
             <p class="statis-cont-tile">学校总数</p>
             <p class="statis-cont-num">125</p>
           </li>
           <li>
             <div class="statistics-bg" style="background-color: #E1FEF6">
               <img class="statistics-img" src="../../common/img/static3.png">
             </div>
             <p class="statis-cont-tile">学生总数</p>
             <p class="statis-cont-num">148572</p>
           </li>
           <li>
             <div class="statistics-bg" style="background-color: #FFF6DE">
               <img class="statistics-img" src="../../common/img/static2.png">
             </div>
             <p class="statis-cont-tile">体测平均分</p>
             <p class="statis-cont-num">76.2</p>
           </li>
           <li>
             <div class="statistics-bg" style="background-color: #FEE4DB">
               <img class="statistics-img" src="../../common/img/static4.png">
             </div>
             <p class="statis-cont-tile">体测优秀率</p>
             <p class="statis-cont-num">12.4%</p>
           </li>
           <li>
             <div class="statistics-bg" style="background-color: #DDDBFE">
               <img class="statistics-img" src="../../common/img/static5.png">
             </div>
             <p class="statis-cont-tile">当日打卡率</p>
             <p class="statis-cont-num">49%</p>
           </li>
         </ul>
       </div>
     </div> -->
    <div class="shortcut">
      <div class="menu-title">
        <div class="blue-icon"></div>
        <p class="blue-text">快捷入口</p>
      </div>
      <div class="shortcut-list">
        <ul>
          <li @click="goPage('personalData')">
            <div class="shortcut-li" >
              <img class="shortcut-icon" src="../../common/img/chengji.png" >
              <p class="shortcut-name">体测成绩</p>
            </div>
            <div class="space"></div>
            <p class="shortcut-info">查询学生体测成绩</p>
          </li>
          <li @click="goPage('dataStats')">
            <div class="shortcut-li" >
              <img class="shortcut-icon" src="../../common/img/tongji.png">
              <p class="shortcut-name">数据统计</p>
            </div>
            <div class="space"></div>
            <p class="shortcut-info">各维度体测数据统计</p>
          </li>
          <li @click="goPage('exercise')">
            <div class="shortcut-li" >
              <img class="shortcut-icon" src="../../common/img/chufang.png">
              <p class="shortcut-name">运动处方</p>
            </div>
            <div class="space"></div>
            <p class="shortcut-info">一对一提升训练计划</p>
          </li>
          <li @click="goPage('question')">
            <div class="shortcut-li" >
              <img class="shortcut-icon" src="../../common/img/jiankangkt.png">
              <p class="shortcut-name">健康课堂</p>
            </div>
            <div class="space"></div>
            <p class="shortcut-info">体育健康知识题库</p>
          </li>
          <li @click="goPage('eyesight')">
            <div class="shortcut-li" >
              <img class="shortcut-icon" src="../../common/img/gym.png">
              <p class="shortcut-name">视力健康</p>
            </div>
            <div class="space"></div>
            <p class="shortcut-info">学生视力数据采集</p>
          </li>
        </ul>
        <ul>
          <li @click="goPage('dailyAdmin')">
            <div class="shortcut-li" >
              <img class="shortcut-icon" src="../../common/img/zuoye.png">
              <p class="shortcut-name">体育作业</p>
            </div>
            <div class="space"></div>
            <p class="shortcut-info">课外家庭体育作业管理</p>
          </li>
          <li @click="goPage('easyUp')">
            <div class="shortcut-li" >
              <img class="shortcut-icon" src="../../common/img/zhongkao.png">
              <p class="shortcut-name">干预提升</p>
            </div>
            <div class="space"></div>
            <p class="shortcut-info">体质精准提升数据分析</p>
          </li>
          <li @click="goPage('healthdata')">
            <div class="shortcut-li" >
              <img class="shortcut-icon" src="../../common/img/dangan.png">
              <p class="shortcut-name">健康档案</p>
            </div>
            <div class="space"></div>
            <p class="shortcut-info">全维度学生健康档案</p>
          </li>
          <li @click="goTmf">
            <div class="shortcut-li" >
              <img class="shortcut-icon" src="../../common/img/tiyukt.png">
              <p class="shortcut-name">体育课堂</p>
            </div>
            <div class="space"></div>
            <p class="shortcut-info">智慧体育课堂管理</p>
          </li>
          <li @click="goPage('studentAdmin')">
            <div class="shortcut-li" >
              <img class="shortcut-icon" src="../../common/img/info.png">
              <p class="shortcut-name">学生信息</p>
            </div>
            <div class="space"></div>
            <p class="shortcut-info">学生基础信息管理</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>


<script>
import {baseUrl, ERR_OK} from 'common/api/api'

export default {
  data() {
    return {
      rootUrl: baseUrl,
      getUserInfoUrl: '/api/common/user/info',
      avatar: 'static/images/header-default.png',
      realName: '',
      role: '',
      userId: '',
      phone: '',
      roleIds: ''
    }
  },
  created: function () {
    this.getUserInfo()
  },
  methods: {
    /* 获取用户信息 */
    getUserInfo() {
      this.$http({
        method: 'post',
        url: this.rootUrl + this.getUserInfoUrl
      }).then((res) => {
        if (res.body.code === ERR_OK) {
          let result = res.body.data.user
          this.avatar = result.imageUrl
          this.realName = result.realName
          this.role = result.roleNames
          this.userId = result.id
          //将用户id存入本地缓存，方便后期调用
          window.localStorage.setItem('userId',result.id)
          this.phone = result.phone
          this.roleIds = result.roleIds
        }
      }, (res) => {
      })
    },
    goPage(pageName) {
      this.getUserInfo()
      this.$router.push({path: pageName})

    },
    logout() {
      window.localStorage.removeItem('token')
      this.$router.push({path: '/'})
    },
    goTmf(){
      var url='http://heart.healthyoung.life/#/login?appKey=21068920&secret=b4508a1b28314e0c96d64ef027f5d6ae'
      window.open(url)
    },
    goLkIndex(){
      var url='https://school.shjkkc.com/dashboard/workplace'
      window.open(url)
    }
  },
  watch: {
    $route(to, from) {
      if (to.fullPath === '/index' && from.fullPath === '/changePerInfo') {
        this.getUserInfo()
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "~common/scss/variable.scss";
.welcome{
  // padding:20px 15px;
  height: -webkit-calc(100% - (0px));
  height: -moz-calc(100% - (0px));
  height: calc(100% - (0px));
  //min-width: 1455px;
  background-color:$color-background;
  border:1px solid $color-border;
}

.welcome-wrapper{
  position:relative;
  height:100%;
  //min-width: 1455px;
  h1{
    padding-bottom:15px;
    border-bottom:2px solid $color-border;
  }
  .welcome-content{
    position:absolute;
    width:100%;
    text-align: center;
    /*top:50%;*/
    margin-top:20px;
    p{
      height:52px;
      line-height: 52px;
    }
  }

}
.blue-icon{
  width: 6px;
  height: 24px;
  background-color: #187CFF;
  float: left;
}
.blue-text{
  font-size: 20px;
  margin-left: 18px;
  line-height: 24px;
}

.statistics{
  height: 414px;
  width: calc(100% - 50px);
  margin-top: 40px;
  margin-left: 40px;
  position: relative;
  .menu-title{
    margin-top: 30px;
  }
  .statistics-list{
    margin-top: 30px;

    ul{
        display: flex;
        justify-content: space-between;
      li{
        //width: calc(20% - 30px);
        width: 20%;
        margin-right: 30px;
        height: 350px;
        background-color: $color-background-white;
        border-radius:12px;
        box-shadow: 0px 0px 9px 0px rgba(0,0,0,0.2);
        //margin-right: 30px;
        //float: left;
        border-color: transparent;
        text-align: center;
        .statistics-bg{
          width: auto;
          height: 160px;
          border-top-right-radius: 12px;
          border-top-left-radius: 12px;
          border-bottom-right-radius: 0px;
          border-bottom-left-radius: 0px;
        }
        .statistics-img{
          width: 80px;
          height: 80px;
          margin-top:40px;
        }
        .statis-cont-tile{
          font-size: 24px;
          margin-top: 52px;
        }
        .statis-cont-num{
          font-size: 24px;
          margin-top: 15px;
        }
      }
    }
  }

}

.shortcut{
  height: 356px;
  //width: calc(100% - 50px);
  margin-top: 20px;
  margin-left: 40px;
  position: relative;
  .menu-title{
    margin-top: 10px;
  }
  .shortcut-list{
    ul{
         display: flex;
        justify-content: space-between;
      li{
        width: 20%;
        //width: calc(20% - 30px);
        //min-width: 250px;
        height: 136px;
        background-color: $color-background-white;
        border-radius:12px;
        box-shadow: 0px 0px 9px 0px rgba(0,0,0,0.2);
        margin-top: 30px;
        margin-right: 30px;
        //float: left;
        border-color: transparent;
        cursor: pointer;
        .space{
          height: 1px;
          background-color: #DDDDDD;
          margin: 25px 20px 18px 20px;
        }
        .shortcut-li{
          text-align: center;
          margin: 0 auto;
          margin-top: 26px;
          //margin-left: 25%;
          width: 144px;
        }
        .shortcut-icon{
          float: left;
          width: 32px;
          height: 32px;
          float: left;

        }
        .shortcut-name{
          line-height: 32px;
          margin-left: 56px;
          font-size: 22px;
        }
        .shortcut-info{
          text-align: center;
          font-size: 16px;
          color: #666666;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/welcome/welcome.vue